import ExportDialog from 'ExportDialog/modal/ExportDialog';
import useToggle from 'academy-common-lib/hooks/useToggle';
import { ActionsMenu } from 'foundations-components/components/ActionsMenu';
import { ExportClient, ExportFormatFormField, createExportLanguageFormField } from '../../../export';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UsageTracker from '../../../../utils/UsageTracker';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import { useUserInfo } from '../../../accounts/accountsQueries.legacy';
import ProgressTransferModal from '../progressTransfer/ProgressTransferModal';
import { DataSyncIcon } from 'foundations-assets/icons/components/DataSyncIcon';
import { DownloadIcon } from 'foundations-assets/icons/components/DownloadIcon';
import { PinIcon } from 'foundations-assets/icons/components/PinIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActionsDropdownMenu = ({
  onUnpinUserChange,
  isUserPinned
}) => {
  const {
    isShowing: isExportDialogShowing,
    show: showExportDialog,
    hide: hideExportDialog
  } = useToggle();
  const {
    isShowing: isTransferAwardsShowing,
    show: showTransferAwards,
    hide: hideTransferAwards
  } = useToggle();
  const {
    userInfo
  } = useUserInfo();
  const userEmail = userInfo ? userInfo.user.emails[0] : '';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ActionsMenu, {
      actions: [{
        text: I18n.text('learningCenter.myTeam.common.actions.exportTeamData'),
        value: 'export-team-data',
        indicator: /*#__PURE__*/_jsx(DownloadIcon, {})
      }, {
        text: I18n.text('learningCenter.myTeam.common.actions.transferProgress'),
        value: 'transfer-awards',
        indicator: /*#__PURE__*/_jsx(DataSyncIcon, {})
      }, ...(onUnpinUserChange && isUserPinned === true ? [{
        text: I18n.text('learningCenter.myTeam.common.actions.unpinUser'),
        value: 'unpin-user',
        indicator: /*#__PURE__*/_jsx(PinIcon, {})
      }] : []), ...(onUnpinUserChange && isUserPinned === false ? [{
        text: I18n.text('learningCenter.myTeam.common.actions.pinUser'),
        value: 'pin-user',
        indicator: /*#__PURE__*/_jsx(PinIcon, {})
      }] : [])],
      menuInlineSize: 275,
      onActionClick: ({
        value
      }) => {
        if (value === 'export-team-data') {
          UsageTracker.track('teamInteraction', {
            action: 'export-all-certification-data-clicked'
          });
          showExportDialog();
        }
        if (value === 'transfer-awards') {
          UsageTracker.track('teamInteraction', {
            action: 'transfer-certifications-clicked'
          });
          showTransferAwards();
        }
        if (value === 'unpin-user') {
          UsageTracker.track('teamInteraction', {
            action: 'unpin-user-clicked'
          });
          onUnpinUserChange === null || onUnpinUserChange === void 0 || onUnpinUserChange(false);
        }
        if (value === 'pin-user') {
          UsageTracker.track('teamInteraction', {
            action: 'pin-user-clicked'
          });
          onUnpinUserChange === null || onUnpinUserChange === void 0 || onUnpinUserChange(true);
        }
      },
      placement: "bottom-end",
      referenceText: I18n.text('learningCenter.myTeam.common.actions.buttonTitle'),
      use: "tertiary-light"
    }), isTransferAwardsShowing && /*#__PURE__*/_jsx(ProgressTransferModal, {
      isOpen: isTransferAwardsShowing,
      onClose: hideTransferAwards
    }), isExportDialogShowing && /*#__PURE__*/_jsx(ExportDialog, {
      client: ExportClient('MY_TEAM'),
      formFields: [ExportFormatFormField, createExportLanguageFormField()],
      headerContents: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.myTeam.export.teamExportDialogHeader"
      }),
      onClose: hideExportDialog,
      onSuccess: () => {
        FloatingAlertStore.addAlert({
          type: 'success',
          message: I18n.text('learningCenter.myTeam.export.notificationBody'),
          titleText: I18n.text('learningCenter.myTeam.export.notificationHeader')
        });
        UsageTracker.track('teamInteraction', {
          action: 'export-completed',
          type: 'MY_TEAM'
        });
      },
      userEmail: userEmail
    })]
  });
};
export default ActionsDropdownMenu;